export const BACK_TO_TOP_BUTTON_VISIBILITY_SCROLL_THRESHOLD = 0.2
export const SEARCH_BRAND_HISTORY_LOCAL_KEY = 'search_brand_history_local_key'
export const SEARCH_BRAND_HISTORY_MAX_ITEMS = 3
export const NEED_LOGGED_IN_ROUTES = ['/profile', '/checkout/shipping', '/checkout/payment']
export const IS_SET_USER_ATTRIBUTE_STORAGE_KEY = 'IS_SET_USER_ATTRIBUTE'

export const CATEGORY_MODAL_HASH = 'menu'
export const SEARCH_MODAL_HASH = 'search'
